<template>
  <div class="required login">
    <div class="logo-wrapper"></div>
    <el-card class="login-form-layout lg:w-1/3 md:w-1/2">
      <el-form autoComplete="off" class="my-5 mx-6" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left">

        <div class="flex justify-center mb-5">
          <el-image style="width: 205px;height: 54px;" :src="baseOSSUrl + '/logo.png'"></el-image>
        </div>

        <div class="flex justify-center mb-8">
          <el-radio-group v-model="loginForm.loginMethod" @change="loginMethodChange" size="medium" fill="#123B7F">
            <el-radio-button :label="1">密码登录</el-radio-button>
            <el-radio-button :label="2">短信登录</el-radio-button>
          </el-radio-group>
        </div>
        <div v-if="loginForm.loginMethod==1">
          <el-form-item prop="username">
            <el-input name="username" type="text" v-model="loginForm.username" autoComplete="off" placeholder="请输入用户名">
            <span slot="prefix">
              <svg-icon icon-class="user" class="color-main"></svg-icon>
            </span>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input name="password" :type="pwdType" v-model="loginForm.password" autoComplete="off" placeholder="请输入密码">
              <span slot="prefix">
                <svg-icon icon-class="password" class="color-main"></svg-icon>
              </span>
              <span slot="suffix" @click="showPwd" class="cursor-pointer">
                <span class="svg-container">
                  <svg-icon icon-class="eye" class="color-main"/>
                </span>
              </span>
            </el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item prop="phone">
            <el-input name="phone" type="text" v-model="loginForm.phone" autoComplete="off" placeholder="请输入手机号">
            <span slot="prefix">
              <svg-icon icon-class="user" class="color-main"></svg-icon>
            </span>
            </el-input>
          </el-form-item>
          <el-form-item prop="verifyCode">
            <el-input name="verifyCode" type="text" v-model="loginForm.verifyCode" autoComplete="off" placeholder="请输入验证码">
              <span slot="prefix">
                <svg-icon icon-class="password" class="color-main"></svg-icon>
              </span>
              <span slot="suffix" >
                <button
                  type="button"
                  class="px-3 py-2 rounded"
                  :class="[!canClick?'verifyBtn':'noActiveVerityBtn']"
                  :disabled="canClick"
                  @click="getVerifyCode"
                >
                  {{ content }}
                </button>
              </span>
            </el-input>
          </el-form-item>
        </div>

        <el-form-item>
          <div class="flex items-center justify-between">
            <div class="flex items-center"></div>
            <div class="text-sm">
              <a href="javascript:;" class="text-sm color-main" @click="updatePassword()">忘记密码?</a>
            </div>
          </div>
        </el-form-item>

        <el-form-item style="text-align: center">
          <el-button style="background-color: #123B7F;border: none;line-height: 0.75rem;" class="w-full" type="primary" :loading="loading" @click.native.prevent="handleLogin">
            登录
          </el-button>
        </el-form-item>
        <div class="flex justify-center">
          <span class="text-sm">新用户?&nbsp;</span>
          <a href="javascript:;" class="text-sm color-main" @click="registerClick()">创建账号</a>
        </div>
      </el-form>

    </el-card>
  </div>
</template>

<script>
import {
baseOSSUrl
} from '@/utils/oss';
import { isvalidUsername } from '@/utils/validate';
export default {
  name: "loginContent",
  data(){
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    };
    return{
      baseOSSUrl,
      loginForm: {
        username: '',
        password: '',
        loginMethod: 1,
        phone:"",
        verifyCode:""
      },
      loginRules: {
        // username: [{required: true, trigger: 'blur', validator: validateUsername}],
        // password: [{required: true, trigger: 'blur', validator: validatePass}]
      },
      loading: false,
      pwdType: 'password',
      dialogVisible:false,
      supportDialogVisible:false,
      content: '获取验证码',
      totalTime: 60,
      canClick: false,
      clock:null
    };
  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store.dispatch('Login', this.loginForm).then(() => {
            this.loading = false;
            this.$router.push({path: '/'})
          }).catch(() => {
            this.loading = false
          })
        } else {
          this.$message('参数验证不合法！');
          return false
        }
      })
    },
    registerClick(){
      this.$router.push({
        path: '/register'
      });
    },
    //修改密码
    updatePassword(){
      this.$router.push({
        path: '/findPassword'
      });
    },
    //登录方式单选事件
    loginMethodChange(val){
      this.$refs["loginForm"].resetFields();
      this.loginForm.loginMethod = val;

      if(this.clock!=null){
        window.clearInterval(this.clock)
        this.content = '获取验证码'
        this.totalTime = 60
        this.canClick = false
      }
    },
    //获取验证码接口
    getVerifyCode(){
      if (this.canClick){
        return
      }else{
        this.canClick = true
        this.content = this.totalTime + 's后重新获取'
        this.clock = window.setInterval(() => {
          this.totalTime--
          this.content = this.totalTime + 's后重新获取'
          if (this.totalTime < 0) {
            window.clearInterval(this.clock)
            this.content = '获取验证码'
            this.totalTime = 60
            this.canClick = false
          }
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>

.login {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/login_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.color-main{
  color: #123B7F;
}

/deep/ .el-input__inner:focus{
  border-color: #123B7F;
}

/deep/ .el-radio-button__inner:hover{
  color: #123B7F;
}

/deep/ .el-input__inner {
  /*width: 220px;*/
  border-radius: 0px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  /*outline: medium;*/
}

.login-form-layout {
  position: absolute;
  left: 0;
  right: 0;
  /*width: 28rem;*/
  margin: 140px auto;
}
.verifyCodeBtn{
  border-color: #123B7F;
}
.verifyCodeBtn:hover{
  background-color: #123B7F;
  color: #FFFFFF;
}

/*修改input placeholder字体大小*/
/deep/ input::-webkit-input-placeholder {
  font-size:0.875rem;

}
/deep/ input::-ms-input-placeholder {
  font-size:0.875rem;
}
.verifyBtn{
  background: #123B7F;
  color:#fff;
  font-size: 14px;
  line-height: 20px;
}
.noActiveVerityBtn{
  background: #ccc;
  color:#fff;
  font-size: 14px;
  line-height: 20px;
}
</style>